import { FC, PropsWithChildren } from 'react'

import styled from 'styled-components'

export type SimpleLabelColor = 'green' | 'grey' | 'red' | 'orange'

export type SimpleLabelProps = PropsWithChildren & {
  className?: string
  color?: SimpleLabelColor
}

const Container = styled.div<SimpleLabelProps>`
  font-family: 'Segoe UI', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 150%;
  border-radius: 16px;
  text-align: center;
  display: inline-flex;
  padding: 3px 6px;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  width: fit-content;

  color: ${({ color, theme }) => {
    switch (color) {
      case 'green':
        return theme.color.darkGreen
      case 'red':
        return theme.color.darkRed
      case 'orange':
        return theme.color.mediumOrange
      case 'grey':
      default:
        return theme.color.darkGrey
    }
  }};

  background-color: ${({ color, theme }) => {
    switch (color) {
      case 'green':
        return theme.color.lightGreen
      case 'red':
        return theme.color.lightRed
      case 'orange':
        return theme.color.lightOrange
      case 'grey':
      default:
        return theme.color.lightGrey
    }
  }};
`

export const SimpleLabel: FC<SimpleLabelProps> = ({
  children,
  className,
  color = 'grey',
}) => (
  <Container className={className} color={color}>
    {children}
  </Container>
)
